module.exports = __webpack_public_path__ + "img/carmen-melean-byn.b7996ecb.jpg";